<template>
  <div class="home" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px;">
   
    <Category/>
  </div>
  
  
</template>

<script>
// @ is an alias to /src
// import offr from '@/components/Items'
import Category from '@/components/Category'
import axios from 'axios';

export default {
   components: {      
        // offr,
        Category,
        
       },
        data: () => ({
            name: 'Search Result',
            products : []
        }),
        mounted() {
          this.name = localStorage.getItem("catName");
           this.getItems();
            this.$parent.$children[0].$parent.ttlval = this.name

            // console.log(this.$el.textContent) 

       },
    methods: {
    getItems: function () {
      // this.loading = true;
      axios.get(this.$bURL+"item/GetItemDetailsList?Category=Bottles&SubCategory=All")
      .then((response)  =>  {
        // this.loading = false;
        // console.log(response)
        // this.products = response.data;
      }, (error)  =>  {
          console.log(error)
      })
    }
  },

 
}
</script>
